import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SearchBox from 'Theme/AppHeader/Components/SearchBox';
import Nav from '../AppNav/VerticalNavWrapper';
import HeaderLogo from '../AppLogo';
import { setEnableMobileMenu } from '../../store/themeOptions/actions';

const AppSidebar = () => {
  const dispatch = useDispatch();

  const {
    backgroundColor,
    enableBackgroundImage,
    enableSidebarShadow,
    backgroundImage,
    backgroundImageOpacity,
    enableMobileMenu,
  } = useSelector(state => state.themeOption);

  const toggleMobileSidebar = () => {
    dispatch(setEnableMobileMenu(!enableMobileMenu));
  };

  return (
    <>
      <div className="sidebar-mobile-overlay" onClick={toggleMobileSidebar} />

      <TransitionGroup>
        <CSSTransition
          component="div"
          className={cx('app-sidebar', backgroundColor, {
            'sidebar-shadow': enableSidebarShadow,
          })}
          appear
          timeout={1500}
          enter={false}
          exit={false}
        >
          <div>
            <HeaderLogo />
            <PerfectScrollbar>
              <div className="app-sidebar__inner">
                <Nav />
              </div>
            </PerfectScrollbar>
            <div
              className={cx('app-sidebar-bg', backgroundImageOpacity)}
              style={{
                backgroundImage: enableBackgroundImage
                  ? `url(${backgroundImage})`
                  : null,
              }}
            />
          </div>
        </CSSTransition>
      </TransitionGroup>
      {/* <InviteUserModal /> */}
    </>
  );
};

export default AppSidebar;
